module.exports = __webpack_public_path__ + "static/media/trial-expired.4b712e07.svg";